import { component } from 'picoapp'

export default component((node, ctx) => {

  let flickityOptions = {
    wrapAround: true,
    pageDots: true,
    autoPlay: 5000,
    pauseAutoPlayOnHover: true
  };

  if ( matchMedia('(min-width: 1200px)').matches ) { // $laptop
    flickityOptions.fade = true;
    flickityOptions.draggable = false;
  }

  const heroFlickity = new Flickity( node, flickityOptions );

  // call resize after the page loads to fix bug with pjax
  setTimeout(function() {
    heroFlickity.resize();
  }, 500);

})
